import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import { addSignalGenerators } from './signal-generator.actions';
import { SignalGenerator, signalGeneratorId, signalGeneratorsMap } from './signal-generator.model';
import { createSignalGeneratorByIdSelector } from './signal-generator.selectors';
import { addTuningControllers } from './tuning-controller.actions';

import { AppState } from './index';

@Injectable()
export class SignalGeneratorEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<AppState>>(Store);

  addSignalGeneratorsOnAddTuningControllers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addTuningControllers),
      withLatestFrom(this.store$),
      map(([action, state]) => {
        const tuningControllers = action.tuningControllers;
        const signalGenerators: SignalGenerator[] = [];

        tuningControllers.forEach((tuningController) => {
          signalGeneratorsMap.get(tuningController.type).forEach((signalGenerator) => {
            const tuningControllerSignalGenerator = createSignalGeneratorByIdSelector(
              signalGeneratorId(signalGenerator, tuningController),
            ).projector(state.signalGenerators.entities);
            if (!tuningControllerSignalGenerator) {
              signalGenerators.push({
                ...signalGenerator,
                id: signalGeneratorId(signalGenerator, tuningController),
                tuningControllerId: tuningController.id,
              } as SignalGenerator);
            }
          });
        });

        return addSignalGenerators({ signalGenerators });
      }),
    ),
  );
}
